<div class="itinerary-model-content-inner">
  <div class="ion-no-padding">
    <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Preview</ion-title>
  </div>

  <div class="phone-frame">
    <div class="whatsapp-header"></div>

    <div class="whatsapp-body">

      <!-- HEADER -->
      <div class="bubble bubble-header" *ngIf="previewData?.templateType === 'text' && previewData?.headerText">
        <small>{{ previewData.headerText }}</small>
      </div>

      <!-- HEADER PLACEHOLDER -->
      <div class="bubble placeholder" *ngIf="previewData?.templateType === 'text' && !previewData?.headerText">
        <small>Header text…</small>
      </div>

      <!-- IMAGE -->
      <div *ngIf="previewData?.image" class="bubble media-bubble">
        <img [src]="imagePreview" />
      </div>

      <!-- IMAGE PLACEHOLDER -->
      <div *ngIf="!previewData?.image && previewData?.templateType === 'image'" class="bubble media-placeholder">
        <div class="placeholder-box">Image preview</div>
      </div>

      <!-- VIDEO -->
      <div *ngIf="previewData?.video" class="bubble media-bubble">
        <video [src]="videoPreview" controls></video>
      </div>

      <!-- VIDEO PLACEHOLDER -->
      <div *ngIf="!previewData?.video && previewData?.templateType === 'video'" class="bubble media-placeholder">
        <div class="placeholder-box">Video preview</div>
      </div>

      <!-- DOCUMENT -->
      <div *ngIf="previewData?.document" class="bubble media-bubble">
        <iframe *ngIf="isPdf" [src]="documentPreview"></iframe>
        <a *ngIf="!isPdf" [href]="documentPreview" target="_blank">Open Document</a>
      </div>

      <!-- DOCUMENT PLACEHOLDER -->
      <div *ngIf="!previewData?.document && previewData?.templateType === 'document'" class="bubble media-placeholder">
        <div class="placeholder-box">Document preview</div>
      </div>

      <!-- BODY -->
      <div class="bubble bubble-body" *ngIf="previewData?.body">
        <div [innerHTML]="previewData.body | whatsappFormat"></div>
      </div>

      <!-- BODY PLACEHOLDER -->
      <div class="bubble placeholder" *ngIf="!previewData?.body">
        <small>Write body text…</small>
      </div>

      <!-- FOOTER -->
      <div class="bubble bubble-footer" *ngIf="previewData?.footer">
        <small>{{ previewData.footer }}</small>
      </div>

      <!-- FOOTER PLACEHOLDER -->
      <div class="bubble bubble-footer placeholder" *ngIf="!previewData?.footer">
        <small>Footer text…</small>
      </div>
      <!-- CALL BUTTONS -->
      <div *ngIf="previewData?.buttonType === 'call'" class="button-group">
        <button *ngFor="let btn of previewData.callButtons">
          {{ btn.text || 'Button' }}
        </button>
      </div>

      <!-- QUICK REPLY BUTTONS -->
      <div *ngIf="previewData?.buttonType === 'quick'" class="button-group">
        <button *ngFor="let reply of previewData.quickReplies">
          {{ reply.text || 'Reply' }}
        </button>
      </div>


      <!-- BUTTON PLACEHOLDER -->
      <!-- <div *ngIf="previewData?.buttonType === 'none'" class="button-placeholder">
        <div class="placeholder-btn">Button preview…</div>
      </div> -->

    </div>

    <div class="chat-input">
      <input placeholder="Type a message" disabled />
      <ion-icon name="attach-outline"></ion-icon>
      <ion-icon name="send"></ion-icon>
    </div>
  </div>
</div>